import React, { useContext } from 'react';
import * as lodash from 'lodash';
import { DataList, createInitialFilters, AppContext } from 'commons-ui';
import { useHistory } from 'react-router-dom';
import { useStyletron } from 'baseui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { Select } from 'baseui/select';
import { Button } from 'baseui/button';
import PriorityTags from '../../../priorityconfigurator/submodules/updatePriorityList/PriorityListTags';
import { styles } from '../../../priorityconfigurator/submodules/updatePriorityList/updatePriorityList.style';
import usePriorityList from '../../../priorityconfigurator/submodules/updatePriorityList/usePriorityList';
import * as dashboardModel from '../../../priorityconfigurator/utils/model';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { activeFilter, columnConfigs } from './listConfig';

const ConfigList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const { segmentLists, submitSegmentPriority, segmentInputText, handleInputChange } = usePriorityList();
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const actions = getActionList();
	const { getCTDConfigData, isActive, setIsActive, requestDisableGlobalCoolOffFlag, segmentList, expDetailsList } = useService();
	const segmentLabelList: { id: string; label: string }[] = [];
	const expLabelList: { id: string; label: string }[] = [];
	let bucketList = {};
	segmentList.forEach((segmentName: string) => segmentLabelList.push({ id: segmentName, label: segmentName }));
	expDetailsList.forEach((expDetails: { expName: string; bucketDetails: { name: string; share: number }[] }) =>
		expLabelList.push({ id: expDetails.expName, label: expDetails.expName })
	);
	expDetailsList.forEach((expDetails: { expName: string; bucketDetails: { name: string; share: number }[] }) => {
		const buckets: string[] = [];
		expDetails?.bucketDetails?.forEach((bucketsInfo: { name: string; share: number }) => {
			buckets.push(`${bucketsInfo.name}(${bucketsInfo.share})`);
		});
		bucketList = {
			...bucketList,
			...{
				[expDetails.expName]: buckets
			}
		};
	});
	if (!lodash.isNil(actions?.addAction)) {
		actions.addAction.segmentList = segmentLabelList;
		actions.addAction.expList = expLabelList;
		actions.addAction.bucketList = bucketList;
	}
	if (!lodash.isNil(actions?.rowActions[1])) {
		actions.rowActions[1].segmentList = segmentLabelList;
		actions.rowActions[1].expList = expLabelList;
		actions.rowActions[1].bucketList = bucketList;
	}
	const [css] = useStyletron();
	const onSubmit = (value: boolean) => {
		requestDisableGlobalCoolOffFlag(app.appName, { globalCoolOfPeriodFlag: value }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating Global CTD Config', { type: 'error' });
					history.goBack();
				} else {
					showAlert('Global Cool of Period updated');
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
			}
		);
	};
	const COOL_OF_PERIOD_OPTIONS = [
		{ id: true, label: 'ENABLED' },
		{ id: false, label: 'DISABLED' }
	];
	if (lodash.isNil(actions?.addAction)) {
		return (
			<>
				<div className={css({ display: 'flex', width: '400px !important' })}>
					<div style={{ margin: '15px' }}>
						<strong style={{ color: 'black', font: 'bold' }}>Global Cool Off Period</strong>
					</div>
					<div>
						<div
							className={css({
								borderStyle: 'solid',
								borderColor: 'black'
							})}>
							<Select
								overrides={{
									ControlContainer: {
										style: ({ $theme }) => ({
											backgroundColor: $theme.colors.contentInverseTertiary
										})
									}
								}}
								labelKey='label'
								valueKey='id'
								searchable={false}
								clearable={false}
								onChange={({ option }) => {
									setIsActive(option);
								}}
								value={[isActive]}
							/>
						</div>
					</div>
				</div>
				<DataList
					fetchData={getCTDConfigData}
					columnConfigs={columnConfigs}
					getActionHandler={getActionHandler}
					actions={actions}
					entity={LIST_ENTITY_NAMES.CTD_CONFIGS}
					initialFilters={createInitialFilters(activeFilter)}
					initialSortDirection='ASC'
					initialSortIndex={1}
				/>
			</>
		);
	}
	return (
		<div style={styles.mainContainer}>
			<div style={styles.priorityList}>
				<h2>User CTD Payout Segments</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.userCtdPayoutSegments]} />
				<div style={styles.updateSection}>
					<textarea
						value={segmentInputText[dashboardModel.ESupportedCTDConfigPriority.userCtdPayoutSegments]}
						style={styles.textarea}
						rows='5'
						name={dashboardModel.ESupportedCTDConfigPriority.userCtdPayoutSegments}
						onChange={handleInputChange}
						placeholder='Enter user ctd payout segment'
					/>
					<button
						type='button'
						onClick={() => submitSegmentPriority(dashboardModel.ESupportedCTDConfigPriority.userCtdPayoutSegments)}
						style={styles.button}>
						Update User CTD Payout Segments
					</button>
				</div>
			</div>
			<div className={css({ display: 'flex', width: '400px !important' })}>
				<div style={{ margin: '15px' }}>
					<strong style={{ color: 'black', font: 'bold' }}>Global Cool Off Period</strong>
				</div>
				<div>
					<div
						className={css({
							borderStyle: 'solid',
							borderColor: 'black'
						})}>
						<Select
							options={COOL_OF_PERIOD_OPTIONS as any}
							overrides={{
								ControlContainer: {
									style: ({ $theme }) => ({
										backgroundColor: $theme.colors.contentInverseTertiary
									})
								}
							}}
							labelKey='label'
							valueKey='id'
							searchable={false}
							clearable={false}
							onChange={({ option }) => {
								setIsActive(option);
							}}
							value={[isActive]}
						/>
					</div>
				</div>
				<Button
					size='compact'
					onClick={() => {
						onSubmit(isActive?.id);
					}}>
					Submit
				</Button>
			</div>
			<DataList
				fetchData={getCTDConfigData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.CTD_CONFIGS}
				initialFilters={createInitialFilters(activeFilter)}
				initialSortDirection='ASC'
				initialSortIndex={1}
			/>
		</div>
	);
};

export default ConfigList;
